export const SESSION_STORAGE = 'sessionStorage';
export const LOCAL_STORAGE = 'localStorage';
export const COOKIE = 'cookie';
